import React from 'react'
import TimelineGraphic from "../../assets/images/timeline-graphic.png"

const DayTimeline = ({ data }) => {
    const { timeBlock } = data
    
    return (
        <section className="the-day">
            <div className="desktop">
                <div className="col left">
                    {timeBlock[0] && (
                        <div className="time-block">
                            <h6>{timeBlock[0].title}</h6>
                            <p className="time-range">{timeBlock[0].timeRange}</p>
                            {timeBlock[0].paragraph && (
                                <div dangerouslySetInnerHTML={{ __html: timeBlock[0].paragraph }}></div>
                            )}
                            <div dangerouslySetInnerHTML={{ __html: timeBlock[0].scheduleItems }}></div>
                        </div>
                    )}
                    {timeBlock[1] && (
                        <div className="graphic-container">
                            <img 
                                src={timeBlock[1].graphic?.localFile?.childImageSharp?.fluid.src}
                            />
                        </div>
                    )}
                    <div className="snack-block">
                        <div className="time">
                            <h6>10:15AM Snack Time</h6>
                        </div>
                    </div>
                    {timeBlock[2] && (
                        <div className="time-block">
                            <h6>{timeBlock[2].title}</h6>
                            <p className="time-range">{timeBlock[2].timeRange}</p>
                            {timeBlock[2].paragraph && (
                                <div dangerouslySetInnerHTML={{ __html: timeBlock[2].paragraph }}></div>
                            )}
                            <div dangerouslySetInnerHTML={{ __html: timeBlock[2].scheduleItems }}></div>
                        </div>
                    )}
                    <div className="snack-block">
                        <div className="time">
                            <h6>1:45PM Snack Time</h6>
                        </div>
                    </div>
                    {timeBlock[3] && (
                        <div className="graphic-container">
                            <img 
                                src={timeBlock[3].graphic?.localFile?.childImageSharp?.fluid?.src}
                            />
                        </div>
                    )}
                    {timeBlock[4] && (
                        <div className="time-block">
                            <h6>{timeBlock[4].title}</h6>
                            <p className="time-range">{timeBlock[4].timeRange}</p>
                            {timeBlock[4].paragraph && (
                                <div dangerouslySetInnerHTML={{ __html: timeBlock[4].paragraph }}></div>
                            )}
                            <div dangerouslySetInnerHTML={{ __html: timeBlock[4].scheduleItems }}></div>
                        </div>
                    )}
                    {timeBlock[5] && (
                        <div className="graphic-container">
                            <img 
                                src={timeBlock[5].graphic?.localFile?.childImageSharp?.fluid?.src}
                            />
                        </div>
                    )}
                </div>
                <div className="middle-col">
                    <img alt="" src={ TimelineGraphic } />
                </div>
                <div className="col right">
                    {timeBlock[0] && (
                        <div className="graphic-container">
                            <img 
                                src={timeBlock[0].graphic?.localFile?.childImageSharp?.fluid?.src}
                            />
                        </div>
                    )}
                    {timeBlock[1] && (
                        <div className="time-block">
                            <h6>{timeBlock[1].title}</h6>
                            <p className="time-range">{timeBlock[1].timeRange}</p>
                            {timeBlock[1].paragraph && (
                                <div dangerouslySetInnerHTML={{ __html: timeBlock[1].paragraph }}></div>
                            )}
                            <div dangerouslySetInnerHTML={{ __html: timeBlock[1].scheduleItems }}></div>
                        </div>
                    )}
                    <span className="spacer"></span>
                    {timeBlock[2] && (
                        <div className="graphic-container">
                            <img 
                                src={timeBlock[2].graphic?.localFile?.childImageSharp?.fluid?.src}
                            />
                        </div>
                    )}
                    <span className="spacer"></span>
                    {timeBlock[3] && (
                        <div className="time-block">
                            <h6>{timeBlock[3].title}</h6>
                            <p className="time-range">{timeBlock[3].timeRange}</p>
                            {timeBlock[3].paragraph && (
                                <div dangerouslySetInnerHTML={{ __html: timeBlock[3].paragraph }}></div>
                            )}
                            <div dangerouslySetInnerHTML={{ __html: timeBlock[3].scheduleItems }}></div>
                        </div>
                    )}
                    {timeBlock[4] && (
                        <div className="graphic-container">
                            <img 
                                src={timeBlock[4].graphic?.localFile?.childImageSharp?.fluid?.src}
                            />
                        </div>
                    )}
                    {timeBlock[5] && (
                        <div className="time-block">
                            <h6>{timeBlock[5].title}</h6>
                            <p className="time-range">{timeBlock[5].timeRange}</p>
                            {timeBlock[5].paragraph && (
                                <div dangerouslySetInnerHTML={{ __html: timeBlock[5].paragraph }}></div>
                            )}
                            <div dangerouslySetInnerHTML={{ __html: timeBlock[5].scheduleItems }}></div>
                        </div>
                    )}
                </div>
            </div>
            <div className="mobile">
               {timeBlock ? timeBlock.map((block, i) => {
                    return (
                        <React.Fragment key={i}>
                            <div className="time-block">
                                <h6>{block.title}</h6>
                                <p className="time-range">{block.timeRange}</p>
                                {block.paragraph && (
                                    <div dangerouslySetInnerHTML={{ __html: block.paragraph }}></div>
                                )}
                                <div dangerouslySetInnerHTML={{ __html: block.scheduleItems }}></div>
                            </div>
                            <div className="graphic-container">
                                <img 
                                    src={block.graphic?.localFile?.childImageSharp?.fluid?.src}
                                />
                            </div>
                        </React.Fragment>
                    )
               }) : null }
            </div>
        </section>
    )
}

export default DayTimeline
